<template lang="html">
  <section class="signup-group" v-if="groupLength">
    <h3 class="signup-group-title">以下小伙伴正在发起拼课，您可以直接参与：</h3>
    <div v-for="(item, index) in groupLists" class="signup-group-content">
      <div class="signup-group-content-avatar">
        <img :src="img" alt=""  v-for="(img, index) in item.userPicArray">
      </div>
      <!-- <div class="signup-group-content-avatar user-holder">
        <img src="../../assets/images/user-holder.png" alt=""  v-for="(img, index) in 3">
      </div> -->
      <div class="signup-group-content-txt">
        <h4>还差<span>{{item.differ}}</span>人成团</h4>
        <p>距结束仅剩<span v-if="!index">{{endDate1}}</span><span v-else>{{endDate2}}</span>:<template v-if="seconds<10">0</template>{{seconds}}</p>
      </div>
      <div @click="joinGroup(index)" class="signup-group-content-btn">
        去拼课
      </div>
    </div>
  </section>
</template>

<script>
import api from '../../lib/api'
export default {
  name: 'SignupGroup',
  props: ['groupLists','groupLength'],
  data () {
    return {
      endTime1: 0,  //毫秒时间
      endTime2: 0,
      endDate1: '00:00:00',  //页面显示的时间
      endDate2: '00:00:00',
      intervalFlag: false,
      seconds: 0,
      timer1: '',
      timer2: ''
    }
  },
  computed: {
    endTimems () {
      let arr = []
      this.groupLists.map((ele, index) => {
        arr.push(ele.distantTime)
      })
      return arr
    },
    groupArray () {
      return this.groupLists
    }
  },
  watch : {
    endTimems: {
      handler : function (e) {
        // 遍历结束时间
        e.map((ele, index) => {
          this.timer1 = setInterval(() => {
            ele -= 1000
            this.endTimems[index] = ele
            if(!index) {
              this.endTime1 = ele
            } else {
              this.endTime2 = ele
            }
          },1000)
        })
      },
      deep:true,
      immediate: true
    },
    endTime1 () {
      this.seconds = 10
      this.endDate1 = this.setDate(this.endTime1)
    },
    endTime2 () {
      this.endDate2 = this.setDate(this.endTime2)
    },
    groupArray: {
      handler : function (e) {
        e.map((ele,index) => {
          if (ele.userPicArray.length <= ele.differ + 1) {
            ele.userPicArray.push(require('../../assets/images/user-holder.png'))
          }
        })
      },
      // immediate: true,
      deep:true,
      immediate: true
    },
  },
  methods: {
    //毫秒转为时分秒展示
    setDate (date) {
      let hours = parseInt(date/1000/60/60)
      let mins = parseInt((date - hours*1000*60*60) /1000/ 60)
      if (mins < 10) {
        mins = '0' + mins
      }
      let secs = parseInt((date - hours*1000*60*60 - mins*1000*60)/1000)
      if (secs < 10) {
        secs = '0' + secs
      }
      if (!this.intervalFlag) {
        this.timer2 = setInterval(()=>{
          this.seconds -= 1
        },100)
      }
      this.intervalFlag = true
      return `${hours}:${mins}:${secs}`
    },
    async joinGroup (index) {
      let { groupId } = this.groupLists[index]
      const { data } = await api.signUp.getGroupInfo(groupId)()
      const { count, successCount } = data
      if ( count === successCount) {
        this.$toast.show({ message: '此团已满，请重新选择哦～' })
      } else {
        this.$emit('buyGroup', groupId, index)
      }
    },
  },
  beforeDestroy () {
    window.clearInterval(this.timer2)
    window.clearInterval(this.timer1)
  }
}
</script>

<style lang="scss">
@charset "UTF-8";
@import "../../style/main";

.signup-group {
  background-color: #fff;
  padding: 0 rem(30);
  font-size: rem(26);
  color: #999999;
  &-title {
    font-size: rem(26);
    height: rem(80);
    line-height: rem(80);
    border-bottom: 1px solid #E4E4E4;
  }
  &-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: rem(30);
    &:nth-child(2) {
      border-bottom: 1px solid #E4E4E4;
    }
    &-txt {
      font-size: rem(28);
      > h4 {
        margin-bottom: rem(16);
        color: #333333;
        > span {
          color: #F03E3A;
        }
      }
      > p {
        > span {
          display: inline-block;
          // width: rem(150);
        }
      }
    }
    &-btn {
      width: rem(120);
      height: rem(48);
      line-height: rem(48);
      color: #F54C00;
      border: 1px solid #F54C00;
      text-align: center;
      border-radius: rem(10);
    }
    &-avatar {
      position: relative;
      width: rem(150);
      height: rem(64);
      > img {
        width: rem(60);
        height: rem(60);
        border: rem(3) solid #fff;
        border-radius: 100%;
        position: absolute;
        &:nth-child(1) {
          left:0;
          z-index: 1;
        }
        &:nth-child(2) {
          left:50%;
          transform: translateX(-50%);
          z-index: 2;
        }
        &:nth-child(3) {
          right:0;
          z-index: 3;
        }
      }
    }
  }
}
</style>
